export default __webpack_public_path__ + "static/media/partners.49557643.png";